import type { CampaignAnalyticsKpi } from "@adpilot/shared";

export interface Formatters {
  formatCurrency: (value: number, currency?: string) => string;
  formatNumber: (value: number, options?: Intl.NumberFormatOptions) => string;
  formatPercent: (value: number, fractionDigits?: number) => string;
}

export function formatKpiValue(
  value: number | null | undefined,
  format: CampaignAnalyticsKpi["format"],
  formatters: Formatters,
  currency?: string | null,
): string {
  if (value == null) return "—";
  if (format === "currency")
    return currency === null ? "—" : formatters.formatCurrency(value, currency);
  if (format === "percent") return formatters.formatPercent(value, 2);
  return formatters.formatNumber(value, { maximumFractionDigits: 2 });
}
